import React from "react";
import "./Home.css";
import image from "../assets/Rajeev Pandya.jpg";

const Home = () => {
  return (
    <div className="home-container">
      <div className="info-section">
        <h1 className="candidate-name">I Am Rajeev Pandya</h1>
        <h2 className="candidate-role">
          Chief Human Resource Officer & Employee Development
        </h2>
        <div className="profile-actions">
          <button className="hire-me-btn" onClick={() => console.log("Hire me!")}>
            Hire Me
          </button>
          <button
            className="download-cv-btn"
            onClick={() => console.log("Download CV")}
          >
            Download CV
          </button>
        </div>
      </div>

      <div className="image-section">
        <div className="image-design">
          <picture>
            <source srcSet={image} media="(min-width: 768px)" />
            <source srcSet={image} media="(min-width: 320px)" />
            <img
              src={image}
              className="profile-image"
              alt="Rajeev Pandya"
              width="800"
              height="600"
              loading="lazy"
            />
          </picture>
          
          {/* Years of Experience section */}
          <div className="years-of-experience">
            <div style={{ fontSize: 42 }}>20</div>
            <div>Years of <br /> Success</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
